<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <vx-card class="mb-5">
        <vs-row vs-w="12" class="mb-5">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="1"
            vs-sm="4"
            vs-xs="12"
          >
            <vs-button
              @click="goBack"
              color="danger"
              type="border"
              icon="keyboard_backspace"
              >Back</vs-button
            >
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="10"
            vs-sm="4"
            vs-xs="12"
          >
            <h3>View Client User</h3>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="1"
            vs-sm="4"
            vs-xs="12"
          >
            <vs-button
              @click="editCompany"
              icon="edit"
              color="danger"
              type="border"
              >Edit</vs-button
            >
          </vs-col>
        </vs-row>
        <vs-divider class="m-5" />
        <div class="vx-row p-5" v-if="userDescription.client_id">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Client:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ clientName }}
          </div>
        </div>

        <div class="vx-row p-5" v-if="userDescription.first_name">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              First Name:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ userDescription.first_name }}
          </div>
        </div>
        <div class="vx-row p-5" v-if="userDescription.surname">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Surname:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ userDescription.surname }}
          </div>
        </div>
        <div class="vx-row p-5" v-if="userDescription.email">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Email:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ userDescription.email }}
          </div>
        </div>
        <div class="vx-row p-5" v-if="userDescription.desk_phone">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Desk Phone:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ userDescription.desk_phone }}
          </div>
        </div>
        <div class="vx-row p-5" v-if="userDescription.mobile_no">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Mobile No.:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ userDescription.mobile_no }}
          </div>
        </div>
        <div class="vx-row p-5" v-if="userDescription.softphone">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              SoftPhone:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ userDescription.softphone }}
          </div>
        </div>
        <div class="vx-row p-5" v-if="userDescription.alternate_phone_1">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Alternate Phone 1:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ userDescription.alternate_phone_1 }}
          </div>
        </div>
        <div class="vx-row p-5" v-if="userDescription.alternate_phone_2">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Alternate Phone 2:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ userDescription.alternate_phone_2 }}
          </div>
        </div>
        <!-- <div class="vx-row p-5" v-if="userDescription.manager">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Manager:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ clientManager }}
          </div>
        </div> -->
        <div class="vx-row p-5" v-if="userDescription.job_role">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Job Role:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ userDescription.job_role }}
          </div>
        </div>
        <div class="vx-row p-5" v-if="userDescription.roles">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              User Role:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ userDescription.roles[0].role }}
          </div>
        </div>
                        <div class="vx-row p-5" v-if="userDescription.user_status">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              User Status:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ clientStatus }}
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>
<script>
// Store Module
import defineAbilitiesFor from '@/config/abilities'
import _ from "lodash";
import moduleClientUsersManagement from "@/store/client-user-management/moduleClientUserManagement.js";
import moduleClientManagement from "@/store/clients-management/moduleClientsManagement.js";

import vSelect from "vue-select";
export default {
  data() {
    return {
                              abilities : null,

      userDescription: [],
      clientUserId: null,
      clientName:null,
      clientManager:null,
      clientStatus:null
    };
  },
  components: {
    "v-select": vSelect,
    moduleClientUsersManagement,
    moduleClientManagement
  },
  created() {
     var self = this
    defineAbilitiesFor().then(function(data){
      self.abilities = data
    }); 
    if (!moduleClientUsersManagement.isRegistered) {
      this.$store.registerModule(
        "clientUsersManagement",
        moduleClientUsersManagement
      );
      moduleClientUsersManagement.isRegistered = true;
    }
    if (!moduleClientManagement.isRegistered) {
      this.$store.registerModule("clientsManagement", moduleClientManagement);
      moduleClientManagement.isRegistered = true;
    }
  },
  mounted() {
    this.clientUserId = this.$route.params.userId;
    this.fetchClientUser(this.clientUserId);
  },
  methods: {
    fetchClientUser(clientUserId) {
      this.$store
        .dispatch("clientUsersManagement/fetchClientUser", clientUserId)
        .then(res => {
          console.log(res);
          if (res) {
            this.userDescription = res.data;
            if (this.userDescription.client_id) {
              this.showClientName(this.userDescription.client_id);
            }
            if (this.userDescription.manager) {
              this.getClientManager(this.userDescription.manager);
            }
            if (this.userDescription.user_status) {
              this.showClientStatus(this.userDescription.user_status);
            }
          }
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.userDescription = true;
            return;
          }
          console.error(err);
        });
    },
    getClientManager(managerUserId) {
      this.$store
        .dispatch("clientUsersManagement/fetchClientUser", managerUserId)
        .then(res => {
          if (res) {
            this.clientManager = res.data.first_name + ' ' + res.data.surname
          }
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.userDescription = true;
            return;
          }
          console.error(err);
        });
    },
    showClientName(clientId) {
      this.$store
        .dispatch("clientsManagement/fetchClient", clientId)
        .then(res => {
          if (res) {
            let response = res.data;
            this.clientName = response.company_name;
          }
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.clientDescription = true;
            return;
          }
          console.error(err);
        });
    },
    showClientStatus(statusId) {
      this.$store
        .dispatch("clientUsersManagement/fetchStatus", statusId)
        .then(res => {
          if (res) {
            let response = res.data;
            this.clientStatus = response.user_status;
          }
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.clientDescription = true;
            return;
          }
          console.error(err);
        });
    },
    goBack: function() {
      this.$router.go(-1);
    },
    editCompany() {
      this.$router.push({ path: `edit/${this.clientUserId}` });
    },
    convertTime(apiTime) {
      // date = Date.parse(apiTime)
      let date = new Date(apiTime);
      return date.toLocaleString();
    }
  }
};
</script>
<style scoped>
.con-vs-popup .vs-popup {
  width: 900px !important;
}

.item.expanded {
  color: black !important;
  background-color: none !important;
}

.vs-icon-bg.bg-small {
  width: 2.5rem;
  height: 2.5rem;
  border: 1px solid red;
  margin: 0px 20px;
  cursor: pointer;
}

.inputx {
  width: 50px;
}
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}
.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}
/* 
.item.expanded{
    background-color:white !important;
    color:black !important;
    cursor: pointer !important;
} */
</style>
